angular.module('agreements')
    .controller('AgreementSelectController', function ($uibModalInstance, data, Agreement, AgreementConst) {

        this.$onInit = () => {
            let modalData = data || {}
            this.baseFilters = angular.copy(modalData.filters) || {}
            this.linkableOrderStatuses = angular.copy(modalData.options && modalData.options.linkableOrderStatuses) || []
            if (this.baseFilters.type === 'ORDER' && this.baseFilters.workflowStatus == null) {
                this.baseFilters.workflowStatus = this.linkableOrderStatuses[0]
            }
            this.orderStatuses = AgreementConst.orderStatuses
            this.timeStatuses = AgreementConst.timeStatuses
            this.reset()
            this.load()
        }

        this.cancel = () => $uibModalInstance.dismiss()
        this.canSelect = item => {
            if (this.baseFilters.type === 'ORDER') {
                return item.type === 'ORDER' && this.linkableOrderStatuses.includes(item.status)
            }
            if (this.baseFilters.type === 'AGREEMENT') {
                return item.type === 'AGREEMENT'
            }
            return true
        }
        this.select = selected => {
            if (this.canSelect(selected)) {
                $uibModalInstance.close(selected)
            }
        }
        this.reset = () => {
            this.filters = angular.copy(this.baseFilters);
            this.timeStatus = Array.isArray(this.filters.status) ? this.filters.status[0] : this.filters.status
        }
        this.onTimeStatusChanged = () => {
            this.filters.status = this.timeStatus == null ? [] : [this.timeStatus]
            this.load()
        }

        this.load = () => {
            let filters = angular.copy(this.filters)
            Agreement.tableAll(filters).$promise.then(result => this.page = result)
        }
    })
